export const InstantIcon = () => {
  return (
    <svg
      className="ic_instant"
      id="レイヤー_1"
      data-name="レイヤー 1"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <title>ic_ok</title>
      <path
        d="M32,16A16,16,0,1,1,16,0,16,16,0,0,1,32,16ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
        fill="#0094cc"
      />
    </svg>
  );
};
